/**
 * Lets new users explore the calendar before completing setup.
 * Stored in sessionStorage — cleared when the tab closes.
 */

import { safeSessionStorage } from "@/lib/safe-session-storage";

const DEFER_KEY = "or:onboarding:deferred";

export function isOnboardingDeferred(): boolean {
  return safeSessionStorage.get(DEFER_KEY) === "1";
}

export function deferOnboarding(): void {
  safeSessionStorage.set(DEFER_KEY, "1");
}

export function clearOnboardingDefer(): void {
  safeSessionStorage.set(DEFER_KEY, "");
  try {
    sessionStorage.removeItem(DEFER_KEY);
  } catch {
    /* ignore */
  }
}
